import axios from 'axios'

export const httpApiV2 = axios.create({
  baseURL: process.env.VUE_APP_API_RECEITUARIO_V2
})